<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar">
	<!-- Sidebar scroll-->

	<!-- Sidebar navigation-->
	<nav class="sidebar-nav">
		<ul id="sidebarnav">
			<li class="users">
				<a [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active" routerLink="/admin/solutions-list" class="menu-item" (click)="hideHamburgerMenu()">
					<i class="ion ion-ios-arrow-forward"> </i>
					<span [translate]="'sidebar/solutions'">Solutions</span>
				</a>
			</li>
			<li class="users">
				<a [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active" routerLink="/admin/suppliers-list" class="menu-item" (click)="hideHamburgerMenu()">
					<i class="ion ion-ios-arrow-forward"> </i>
					<span [translate]="'sidebar/suppliers'">Suppliers</span>
				</a>
			</li>
			<li class="users">
				<a [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active" routerLink="/admin/generate-city-profile-link" class="menu-item" (click)="hideHamburgerMenu()">
					<i class="ion ion-ios-arrow-forward"> </i>
					<span [translate]="'sidebar/diagnose'">Diagnose Form Link</span>
				</a>
			</li>
			<li class="users">
				<a [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active" routerLink="/admin/all-updates" class="menu-item" (click)="hideHamburgerMenu()">
					<i class="ion ion-ios-arrow-forward"> </i>
					<span [translate]="'sidebar/updates'">All Updates</span>
				</a>
			</li>
		</ul>
	</nav>
	<!-- End Sidebar navigation -->
	<!-- End Sidebar scroll-->
	<!-- Bottom points-->
	<div class="sidebar-footer">

	</div>
	<!-- End Bottom points-->
</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->